module.exports = __webpack_public_path__ + "files/013e741a50c56223701fdb78b0cfcc01.png";